import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './local-storage.service';

/** GET /api/v1/tenants/current — tenant display name (school name) for UI. */
export interface TenantCurrentDto {
  id?: number;
  name?: string;
  displayName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  private readonly url = `${environment.apiUrl}/api/v1/tenants/current`;

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService
  ) { }

  /** Prefer API; fallback to name saved at login. */
  getDisplayName(): Observable<string> {
    return this.http.get<TenantCurrentDto>(this.url).pipe(
      map(t => (t.displayName || t.name || '').trim()),
      catchError(() => of(this.localStorage.getSchoolDisplayName() || ''))
    );
  }
}
